import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'

interface ChartControlsProps {
  days: number
  stepSeconds: number
  refreshSeconds: number
  onDaysChange: (days: number) => void
  onStepSecondsChange: (stepSeconds: number) => void
  onRefreshSecondsChange: (seconds: number) => void
  isLoading?: boolean
}

const periodOptions = [
  { value: 1, label: '1 day' },
  { value: 2, label: '2 days' },
  { value: 4, label: '4 days' },
]

const intervalOptions = [
  { value: 900, label: '15 min' },
  { value: 1800, label: '30 min' },
  { value: 3600, label: '1 hour' },
  { value: 7200, label: '2 hours' },
]

const refreshOptions = [
  { value: 10, label: '10s' },
  { value: 30, label: '30s' },
  { value: 60, label: '60s' },
  { value: 120, label: '2 min' },
]

function PillGroup({ label, options, value, onChange, isLoading }: {
  label: string
  options: { value: number; label: string }[]
  value: number
  onChange: (v: number) => void
  isLoading?: boolean
}) {
  return (
    <div className="flex flex-col gap-2">
      <label className="text-detail font-medium text-muted-foreground">{label}</label>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => (
          <Button
            key={option.value}
            size="sm"
            variant={value === option.value ? 'default' : 'outline'}
            onClick={() => onChange(option.value)}
            disabled={isLoading}
            className={cn(
              'rounded-full',
              isLoading && 'opacity-50 cursor-not-allowed'
            )}
          >
            {option.label}
          </Button>
        ))}
      </div>
    </div>
  )
}

export function ChartControls({
  days,
  stepSeconds,
  refreshSeconds,
  onDaysChange,
  onStepSecondsChange,
  onRefreshSecondsChange,
  isLoading,
}: ChartControlsProps) {
  return (
    <div className="bg-muted rounded-md p-4 mb-6 border">
      <div className="flex flex-wrap gap-6">
        <PillGroup label="Chart Period" options={periodOptions} value={days} onChange={onDaysChange} isLoading={isLoading} />
        <PillGroup label="Chart Interval" options={intervalOptions} value={stepSeconds} onChange={onStepSecondsChange} isLoading={isLoading} />
        <PillGroup label="Refresh" options={refreshOptions} value={refreshSeconds} onChange={onRefreshSecondsChange} isLoading={isLoading} />
      </div>
    </div>
  )
}
